module.exports = __webpack_public_path__ + "static/media/Sn.5f9def86.svg";